/*
    Web View  Module
*/
import cloneDeep from 'lodash/cloneDeep';
import webViewConfigBuilder from './web-view-config-builder';
import chartUtils from '../../../utils/chart-utils';

var webView = function webView() {
	// Render Web View widget
	var renderWidget = function renderWidget(widgetConfig) {
		var ContainerId = widgetConfig.ContainerId,
		    Height = widgetConfig.Height,
		    WebViewConfig = widgetConfig.WebViewConfig,
		    Width = widgetConfig.Width,
		    Context = widgetConfig.Context,
		    Data = widgetConfig.Data;


		var el = document.querySelector('#' + ContainerId);
		var height = Number(chartUtils.replaceAll(Height, '\x01', ''));
		var width = Number(chartUtils.replaceAll(Width, '\x01', ''));
		var invalidLink = 'http://giving.an/completely/invalid_link.jpg';
		var targetUrl = void 0;
		var youtubePrefixes = ['youtube.com/watch?v=', 'youtu.be/', 'youtube.com/embed/'];
		var vimeoPrefixes = ['vimeo.com/'];
		var context = Context !== null && Context.trim().length > 0 ? JSON.parse(Context) : null;

		var videoId = function videoId(str, prefixes) {
			var cleaned = str.replace(/^(https?:)?\/\/(www\.)?/, '');
			var prefixesLength = prefixes.length;
			for (var index = 0; index < prefixesLength; index++) {
				if (cleaned.indexOf(prefixes[index]) === 0) return cleaned.substr(prefixes[index].length);
			}
			return undefined;
		};

		var buildUrl = function buildUrl(targetUrl) {
			var pathArray = targetUrl.split('/');

			var youtubeId = void 0,
			    vimeoId = void 0;

			if (typeof pathArray[2] === 'undefined') return invalidLink;

			var hostWeb = pathArray[2].split('.');
			if (hostWeb[0] === 'youtu' || hostWeb[1] === 'youtube') {
				youtubeId = videoId(targetUrl, youtubePrefixes);

				if (youtubeId === undefined) return invalidLink;

				return youtubeId.includes('?') ? 'https://www.youtube.com/embed/' + youtubeId + '&autoplay=1&mute=1' : 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&mute=1';
			}

			if (hostWeb[0] === 'vimeo') {
				vimeoId = videoId(targetUrl, vimeoPrefixes);

				if (vimeoId === undefined) return invalidLink;

				return vimeoId.includes('?') ? 'https://player.vimeo.com/video/' + vimeoId + '&autoplay=1&muted=1' : 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1';
			}

			return targetUrl;
		};

		var urlContainer = document.createElement('div');
		urlContainer.setAttribute('class', 'urlContainer');
		el.appendChild(urlContainer);

		if ($('#ContainerId .urlContainer > p').length) {
			$('#ContainerId .urlContainer > p').hide();
		}

		var invalidUrlMessage = '<p style="text-align:center">Please enter valid URL!</p>';
		var frameContainer = document.createElement('object');
		frameContainer.setAttribute('id', 'frameContainer-' + ContainerId);
		urlContainer.appendChild(frameContainer);
		var container = document.getElementById('frameContainer-' + ContainerId);
		container.setAttribute('style', 'width:' + width + 'px;height:' + height + 'px');

		var queryParams = null;
		if (WebViewConfig.Fields !== null) {
			//If a 'context' is present, the context information
			//will take highest priority.
			//Remove any parameter fields that overlap with the
			//context information.
			var fields = context !== null && context.FieldName !== null ? WebViewConfig.Fields.filter(function (item) {
				return item.KeyName !== null && item.KeyName.toLowerCase() !== context.FieldName.toLowerCase();
			}) : WebViewConfig.Fields;

			queryParams = fields.map(function (field) {
				return {
					key: field.HeaderName ? field.HeaderName : field.KeyName,
					value: field.KeyName === null ? field.StaticKey : Data !== null && Data.Data !== null && Data.Data.length > 0 ? Data.Data[0][field.KeyName] : null
				};
			});
		}

		if (context !== null && context.FieldName !== null && context.Value !== null) {
			var contextQueryParam = {
				key: context.FieldName,
				value: context.Value
			};

			if (queryParams === null) queryParams = [];

			queryParams.push(contextQueryParam);
		}

		targetUrl = buildUrl(WebViewConfig.Url);

		if (queryParams !== null) {
			queryParams.forEach(function (queryParam) {
				if (queryParam.key !== null && queryParam.value !== null) targetUrl = targetUrl.includes('?') ? targetUrl + '&' + queryParam.key + '=' + queryParam.value : targetUrl + '?' + queryParam.key + '=' + queryParam.value;
			});
		}

		container.setAttribute('data', targetUrl);

		setTimeout(function () {
			if ($('#frameContainer-' + ContainerId)[0].offsetHeight === 0 && $('#frameContainer-' + ContainerId)[0].offsetWidth === 0) {
				$('#' + ContainerId + ' .urlContainer')[0].innerHTML = invalidUrlMessage;
				$('#' + ContainerId + ' .urlContainer > p').show();
			}
		}, 500);
	};

	// Initiate rendering for a widget
	var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
		// Get widget specific widgetConfig
		var widgetConfig = webViewConfigBuilder.configBuilder(cloneDeep(configObj));
		renderWidget(widgetConfig);
	};
	return {
		renderWidget: renderWidget,
		initiateWidgetRendering: initiateWidgetRendering
	};
};

export default webView();